<template>
  <div
    :class="['detail', !wide ? 'detail--small' : false]"
  >
    <Label
      :text="label"
      data-anim="title"
      data-view="false"
      data-size="small"
      class="detail__label"
    />
    <Paragraph
      :text="text"
      size="normal"
      data-anim="text"
      data-view="false"
    />
    <div
      class="detail__line"
      data-anim="line"
      data-view="false"
    />
  </div>
</template>

<script>
import Label from '@/components/text/Label.vue';
import Paragraph from '@/components/text/Paragraph.vue';

export default {
  name: 'Detail',

  components: {
    Label,
    Paragraph,
  },

  props: {
    label: {
      type: String,
      required: true,
    },

    text: {
      type: String,
      required: true,
    },

    wide: {
      type: Boolean,
      required: false,
      default: true,
    }
  }
};
</script>

<style lang="scss" scoped>
.detail {
  position: relative;
  padding-bottom: rem(10px);

  &--small {
    display: inline-block;
  }

  &__label {
    margin-bottom: rem(15px);
  }

  &__line {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 1px;

    background-color: $color-dark-light;
  }
}
</style>

<style lang="scss">
.detail {
  p {
    margin: 0;
  }
}
</style>

